import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=1f8dd2dc&scoped=true&"
import script from "./notification.vue?vue&type=script&lang=ts&"
export * from "./notification.vue?vue&type=script&lang=ts&"
import style0 from "./notification.vue?vue&type=style&index=0&id=1f8dd2dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8dd2dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBadge,VBtn,VIcon,VMenu})
